<div class="mb-4 mx-lg-4 mx-md-4 mx-sm-0">
    <ul class="nav nav-tabs summary-tabs">
        <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="activeTab() === 'summary'"
                (click)="setActiveTab('summary')">
                Summary
            </button>
        </li>
        <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="activeTab() === 'auditLog'"
                (click)="setActiveTab('auditLog')">
                Audit Log
            </button>
        </li>
    </ul>

    @if (activeTab() === 'summary') {
        <div class="card border-0 shadow-sm mb-4 summary-tab-card">
            <div class="card-body p-4 position-relative">
                <ng-container *ifHasPermission="{ requiredPermissions: [FinancialsPermission.UpdateBudget], userPermissionOnly: false, dataEntityType: DataEntityTypes.User }">
                    @if (budgetId) {
                        <a class="btn btn-primary budget-edit-button"
                            [class.disabled]="isBudgetDeleted()"
                            [attr.aria-disabled]="isBudgetDeleted() ? 'true' : null"
                            [attr.tabindex]="isBudgetDeleted() ? -1 : null"
                            [routerLink]="isBudgetDeleted() ? null : ['/budgets', budgetId, 'edit']">
                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />
                            Edit Budget
                        </a>
                    }
                </ng-container>

                <ms-budget-summary-header
                    [summary]="budgetSummary()"
                    [isLoading]="isLoading()" />

                <ms-budget-summary-chart
                    [summary]="budgetSummary()"
                    [isLoading]="isLoading()" />
            </div>
        </div>

        <ms-budget-summary-section
            title="Revenue Budget"
            sectionKind="revenue"
            [section]="budgetSummary()?.revenue"
            [currency]="budgetSummary()?.currency"
            [isLoading]="isLoading()" />

        <ms-budget-summary-section
            title="Expense Budget"
            sectionKind="expenses"
            [section]="budgetSummary()?.expenses"
            [currency]="budgetSummary()?.currency"
            [isLoading]="isLoading()" />
    }

    @if (activeTab() === 'auditLog' && budgetId) {
        <div class="card border-0 shadow-sm mb-4 summary-tab-card">
            <div class="card-body p-4">
                <ms-audit-logs
                    [entityId]="budgetId"
                    [entityType]="AuditEntityType.Budget">
                </ms-audit-logs>
            </div>
        </div>
    }
</div>
